import React, {Fragment,Component,useState,useEffect} from 'react';
import {connect} from 'react-redux';
import Iframe from "react-iframe"
import { Redirect,Link } from 'react-router-dom';
import { Table,Placeholder } from 'semantic-ui-react';

import {
  Menu,
  Message,
  Segment,
  Container,
  Divider,
  Icon,
  Header,
  Dimmer,
  Responsive,
  Modal,
  Button,
  Image,
  Loader,
  Tab,
  Label
} from 'semantic-ui-react';
import {Base64} from 'js-base64';
import Clipboard from 'react-clipboard.js';

function Guide(props){

  const {t}       = props;
  const mobile    = /Android|iPhone|iPod/.test(navigator.userAgent);
  const title     = props.data.title;
  const port      = props.data.port;
  const password  = props.data.password;
  const code      = props.data.code;
  const hashed    = props.data.hashed;
  const user_id   = props.data.user_id;
  const user_vip  = props.data.user_vip;

  const winDownload         = "https://glados.one/tools/Clash.for.Windows.Setup.exe";
  const clashDownload       = "https://glados.one/tools/clash_for_android.apk";
  const macDownload         = "https://glados.one/tools/ClashX.dmg";
  const proDownload         = "https://glados.one/tools/clashx-pro.dmg";
  const vergeDownload       = "https://glados.one/tools/clash-verge.dmg";

  //subscribe_endpoint = "update.glados-config.net";
  //subscribe_endpoint = "update.glados-config.org";
  var subscribe_endpoint = "update.glados-config.com";
  var alt_subscribe_endpoint = "www.glados-config.com";

  const sub    = 'sub://' + Base64.encode(`https://${subscribe_endpoint}/subscribe/${user_id}/${code}/${port}/servers`) + "#Github.com/GLaDOS-network";
  const suburl           = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml`
  const altsub           = `https://${alt_subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml`

  const stashurl         = `https://${subscribe_endpoint}/stash/${user_id}/${code}/${port}/glados.yaml`

  const ipv6             = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-ipv6.yaml`
  const padavan_suburl   = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-padavan.yaml`
  const android_suburl   = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml`
  const koolshare_suburl = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/koolshare.yaml`
  const openclash_suburl = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-openclash.yaml`
  const clash_restrict_suburl = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.restrict.yaml`

  var panes = [{
      desktop:true,
      mobile:true,
      menuItem:<Menu.Item key='pro2'>
        <svg id="windows" style={{"color":"#333","width":"26px","marginRight":"8px", "verticalAlign": "middle"}}   viewBox="0 0 36 24">
          <path d="M6.5 3.27934L15.9055 1.99281V11.051H6.5V3.27934ZM17.0384 1.81427L29.5 0V10.9749H17.0384V1.81427ZM6.5 12.0094H15.9055V21.0938L6.5 19.7811V12.0094ZM17.0384 12.1301H29.5V23L17.0384 21.2409" fill="currentColor"></path>
        </svg>
        Clash For Windows
      </Menu.Item>,
      render: () => {

        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
          <p style={{color:"black"}}>1. 点击下载 <a  href={winDownload}>Clash For Windows 客户端</a>, 然后安装</p>
          <p>2. 右键管理员权限运行 Clash 客户端后，<button><a href={`clash://install-config?url=${suburl}&name=GLaDOS`}>鼠标左键点击这里</a></button>  添加订阅地址, 并点击下载按钮</p>
          <p style={{color:"red"}}>3. 选择General面板, 打勾 System Proxy(系统代理)</p>
          <p>4. 打开浏览器访问 Google.com 测试</p>

          <p>如果无法自动导入，请进入 Clash 的 Profile 面板下载配置文件(
            <span>{suburl}</span>
            <Clipboard
              style={{"borderRadius": "5px", "padding": "4px"}}
              onSuccess={()=>{ setClipboard(true) }}
              data-clipboard-text={suburl}>
              { clipboard ? "copied" : "copy to clipboard" }
            </Clipboard>
          ), 然后选择生效</p>

          <p>如果遇到订阅配置文件失败:</p>
          <ul>
            <li>订阅前关闭系统代理, 再试</li>
            <li>修改系统 DNS 为 119.29.29.29, 再试</li>
          </ul>

          <p>Clash For Windows 注意事项:</p>
          <ul>
            <li>请设置为系统代理</li>
            <li>Clash 因为升级/设置问题出错，请点击"General -> Home Directory", 然后删除目录里的文件和子目录, 再重新订阅。</li>
            <li>请打开订阅文件自动更新功能</li>
            <li>默认使用Rule模式，不要改为全局或直接连接</li>
          </ul>

        </Tab.Pane>)
      }
    },
    {
      desktop:true,
      menuItem:<Menu.Item key='pro3'>
        <svg id="macos" viewBox="0 0 36 24" style={{"color":"#333","width":"28px","marginRight":"8px", "verticalAlign": "middle"}} >
          <path fillRule="evenodd" clipRule="evenodd" d="M15.8794 12.7011C16.0168 10.3047 17.0395 6.40098 19.2618 2H8C6.89543 2 6 2.89543 6 4V20C6 21.1046 6.89543 22 8 22H19.3675C19.1836 20.8126 19.1204 19.6274 19.1251 18.5173C18.6765 18.5758 18.2212 18.6074 17.7647 18.6074C16.1518 18.6074 14.553 18.2135 13.2161 17.6272C11.8949 17.0477 10.7514 16.2451 10.1175 15.3648C9.88356 15.0399 9.95732 14.5868 10.2823 14.3528C10.6072 14.1189 11.0603 14.1926 11.2942 14.5176C11.7192 15.1078 12.6052 15.7759 13.7986 16.2993C14.9764 16.8159 16.3776 17.1574 17.7647 17.1574C18.2344 17.1574 18.7057 17.1182 19.1695 17.0463C19.2362 15.825 19.3653 14.7574 19.4682 13.9668H17.0882C16.4229 13.9668 15.8383 13.4198 15.8794 12.7011ZM20.578 18.2311C21.1884 18.0702 21.7723 17.8645 22.3133 17.6272C23.6346 17.0477 24.7781 16.2451 25.4119 15.3648C25.6459 15.0399 25.5721 14.5868 25.2472 14.3528C24.9222 14.1189 24.4691 14.1926 24.2352 14.5176C23.8102 15.1078 22.9243 15.7759 21.7309 16.2993C21.3857 16.4507 21.0213 16.587 20.6438 16.7041C20.7199 15.5944 20.844 14.6233 20.9397 13.8982C21.0365 13.164 20.4648 12.5168 19.7277 12.5168H17.346C17.5383 10.2196 18.5895 6.37024 20.8934 2H28C29.1046 2 30 2.89543 30 4V20C30 21.1046 29.1046 22 28 22H20.8358C20.6199 20.723 20.5588 19.4319 20.578 18.2311ZM12.5 6.275C12.9004 6.275 13.225 6.59959 13.225 7V9.35294C13.225 9.75335 12.9004 10.0779 12.5 10.0779C12.0996 10.0779 11.775 9.75335 11.775 9.35294V7C11.775 6.59959 12.0996 6.275 12.5 6.275ZM24.225 7C24.225 6.59959 23.9004 6.275 23.5 6.275C23.0996 6.275 22.775 6.59959 22.775 7V9.35294C22.775 9.75335 23.0996 10.0779 23.5 10.0779C23.9004 10.0779 24.225 9.75335 24.225 9.35294V7Z" fill="currentColor"></path>
        </svg>
        ClashX For MacOS
      </Menu.Item>,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>

          <h4><b>ClashX</b></h4>
          <p style={{color:"black"}}>1. 点击下载 <a  href={macDownload}>ClashX 客户端</a>, 安装 ClashX</p>
          <p>2. 运行 ClashX 后，<button><a href={`clash://install-config?url=https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml&name=GLaDOS`}>左键点击这里添加订阅</a></button> 备注填写 GLaDOS</p>
          <p>3. 点击屏幕最右上方的 ClashX 菜单，勾选设为系统代理(set System Proxy) </p>
          <p>4. 用浏览器打开 Google.com</p>
          <p>如果第二步 ClashX 没有响应，请手动添加Clash订阅地址 {`https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml`} </p>
          <p>ClashX 注意事项:</p>
          <ul>
            <li>默认使用Rule模式，不要改为全局或直接连接</li>
            <li>推荐设置系统代理和开机运行。</li>
            <li>打开自动更新功能</li>
          </ul>
          <h4><b>ClashX Pro</b></h4>
          <p>专业版 ClashX Pro <a href={proDownload}>下载</a></p>
          <p>
            支持增强模式, 开启增强模式(Enhanced Mode)可以让其他软件不设置代理就可以通过代理发送网络请求
          </p>
          <p>Clash订阅地址: <Clipboard
              style={{"borderRadius": "5px", "padding": "4px"}}
              onSuccess={()=>{ setClipboard(true) }}
              data-clipboard-text={suburl}>
              { clipboard ? "copied" : "copy to clipboard" }
            </Clipboard>
          {`https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml`} 
          </p>
          <p>增强模式可以实现:</p>
          <ul>
            <li>更快的浏览器打开速度</li>
            <li>加速命令行程序，如 GIT/GO/NPM 等开发工具</li>
            <li>加速非浏览器程序，如Line/Telegram</li>
          </ul>
          <h4><b>Stash(Paid)</b></h4>
          <p>购买 https://stash.ws/</p>
          <p>Clash订阅地址: <Clipboard
              style={{"borderRadius": "5px", "padding": "4px"}}
              onSuccess={()=>{ setClipboard(true) }}
              data-clipboard-text={stashurl}>
              { clipboard ? "copied" : "copy to clipboard" }
            </Clipboard>
          {`https://${subscribe_endpoint}/stash/${user_id}/${code}/${port}/glados.yaml`} 
          </p>
          <h4><b>Clash Verge</b></h4>
          <p>Clash  Verge 是一个跨平台的客户端 <a href={vergeDownload}>下载</a>/<a href="https://github.com/zzzgydi/clash-verge">Github</a></p>
          <p>Clash订阅地址: <Clipboard
              style={{"borderRadius": "5px", "padding": "4px"}}
              onSuccess={()=>{ setClipboard(true) }}
              data-clipboard-text={suburl}>
              { clipboard ? "copied" : "copy to clipboard" }
            </Clipboard>
          {`https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml`} 
          </p>

        </Tab.Pane>)
      } },
    {
      desktop:true,
      menuItem:<Menu.Item key='pro3422'>
      <svg id="linux" viewBox="0 0 36 24" style={{"color":"#333","width":"30px","marginRight":"8px", "verticalAlign": "middle"}} >
      <path fillRule="evenodd" clipRule="evenodd" d="M6 3.5C6 2.67157 6.67157 2 7.5 2H27.5C28.3284 2 29 2.67157 29 3.5V20.5C29 21.3284 28.3284 22 27.5 22H7.5C6.67157 22 6 21.3284 6 20.5V3.5ZM8.96967 4.96967C9.26256 4.67678 9.73744 4.67678 10.0303 4.96967L13.5303 8.46967C13.8232 8.76256 13.8232 9.23744 13.5303 9.53033L10.0303 13.0303C9.73744 13.3232 9.26256 13.3232 8.96967 13.0303C8.67678 12.7374 8.67678 12.2626 8.96967 11.9697L11.9393 9L8.96967 6.03033C8.67678 5.73744 8.67678 5.26256 8.96967 4.96967ZM13 15.2C12.5582 15.2 12.2 15.5582 12.2 16C12.2 16.4418 12.5582 16.8 13 16.8H20.5C20.9418 16.8 21.3 16.4418 21.3 16C21.3 15.5582 20.9418 15.2 20.5 15.2H13Z" fill="currentColor"></path>
      </svg>
      Linux
      </Menu.Item>,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>
          <h3><b>Clash Verge Ubuntu Desktop</b></h3>
          <p>1. 下载客户端 <a href="/tools/clash-verge_1.3.8_amd64.deb">Clash Verge</a></p>
          <p>2. sudo apt install ./clash-verge_1.3.8_amd64.deb </p>
          <p>3. 在软件列表找到clash verge</p>
          <p>4. 导入:
            <Clipboard
              style={{"borderRadius": "5px", "padding": "4px"}}
              onSuccess={()=>{ setClipboard(true) }}
              data-clipboard-text={suburl}>
              { clipboard ? "copied" : "copy to clipboard" }
            </Clipboard>
            <Label>{suburl}</Label>
          </p>
          <p>5. 确认系统代理工作配置和工作正常</p>
          <h3><b>CFW</b></h3>
          <p>Clash for Windows 支持桌面Linux, 使用上与稍有不同，请按照以下方式运行:</p>
          <p>1. 下载客户端: <a href="/tools/Clash.for.Windows-0.20.4-x64-linux.tar.gz">X86</a>/<a href="/tools/Clash.for.Windows-0.20.4-arm64-linux.tar.gz">ARM</a></p>
          <p>2. 解压后，点击CFW运行Clash</p>
          <p>3. 点击Profile, 输入订阅地址:
            <Clipboard
              style={{"borderRadius": "5px", "padding": "4px"}}
              onSuccess={()=>{ setClipboard(true) }}
              data-clipboard-text={suburl}>
              { clipboard ? "copied" : "copy to clipboard" }
            </Clipboard>
            <Label>{suburl}</Label> 并点击Download, 选中新配置文件
          </p>
          <p>4. 使用Clash有两种方式:</p>
          <p><b>4.1 TUN 方式:</b></p>
          <p>4.1.1 打开Clash的主界面，点击Service Mode, 点击安装</p>
          <p>4.1.2 重启Clash，确认 Service Mode 右边的图标为绿色</p>
          <p>4.1.3 点击 TUN MODE，打开浏览器确认，系统配置完成。</p>
          <p>4.1.4 如果需要关闭，点击 TUN MODE 关闭即可。</p>
          <p><b>4.2 系统代理方式:</b></p>
          <p>4.2.1 打开Clash的主界面，查看Port右边的端口号X。</p>
          <p>4.2.2 打开系统的网络选项，选择网络代理，设置为手动模式，Socks 地址为127.0.0.1 端口设置为上一步的端口号X。</p>
          <p>4.2.3 打开浏览器确认，系统配置完成。</p>
          <p>4.2.4 如果需要关闭，选择网络代理，设置为关闭。</p>
          <h3><b>Clash on Server</b></h3>
          <p>非桌面环境, 请<Link to="/console/terminal">点击前往终端配置说明页面</Link></p>
        </Tab.Pane>)
      }
    }


  ]

  const [clipboard,setClipboard] = useState(false);

  useEffect(()=>{
    if(clipboard == true){
      setTimeout(()=>{
        setClipboard(false)
      },3000)
    }
  },[clipboard])

  return (
  <Fragment>

    <Header as='h2' color="blue">
      {t("settings.clash.title")}
      <Header.Subheader>
      {t("settings.clash.notes")}
      </Header.Subheader>
    </Header>

    <p>{t("settings.clash.steps")}</p>
    <p>1.{t("settings.clash.step1")}</p>
    <p>2.{t("settings.clash.step2")}</p>
    <p>3.{t("settings.clash.step3")}</p>

    <Message id="m4" style={{boxShadow:"none"}} icon>
      <Icon color='red' name="check circle" />
      <Message.Content>
        <Message.Header>Attention</Message.Header>
        <p>Clash 开源项目已经不在更新，CFW 和 ClashX 因此停止, 为了保持最佳使用体验，我们建议您更换为Meta/Mihomo/Stash/Singbox/Shadowrocket等客户端。</p>
      </Message.Content>
    </Message>

    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan='3'>
            {t("settings.clash.tab.title")}
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        <Segment>
          <Tab  menu={{ color:"blue", secondary: true}} panes={panes} />
        </Segment>
      </Table.Body>
    </Table>

  </Fragment>
  )
}
export {Guide};
